import tool from './Tool'
import BIPtools from './GetBIPtools'

export default {
  tool,
  BIPtools
}



//////////////////
// WEBPACK FOOTER
// ./utils/index.js
// module id = null
// module chunks = 